import { atom } from 'jotai'

export const contactModalOpenAtom = atom(false)
